import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { MenuItem } from '@wordpress/components';
export default function BlockConvertButton(_ref) {
  let {
    shouldRender,
    onClick,
    small
  } = _ref;

  if (!shouldRender) {
    return null;
  }

  const label = __('Convert to Blocks');

  return createElement(MenuItem, {
    onClick: onClick
  }, !small && label);
}
//# sourceMappingURL=block-convert-button.js.map